import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { matchInteriorsToFrames } from 'rangeConfig/besta/filters/mainMenuProductFilters';
import addProduct from 'rangeConfig/besta/behaviors/addProduct';

const interiorsProductListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText',
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: ['type', 'name', 'typeName', 'design'],
  productFilters: [matchInteriorsToFrames],
  sortOrder: [],
  categories: [
    {
      id: 'shelf',
      categoryTitle: 'typeName',
      products: [{ path: 'type', value: ProductType.BESTA_SHELF }],
      cluster: ['design']
    },
    {
      id: 'glassShelf',
      categoryTitle: 'typeName',
      products: [{ path: 'type', value: ProductType.BESTA_GLASS_SHELF }],
      cluster: ['design']
    },
    {
      id: 'bottleRack',
      categoryTitle: 'typeName',
      products: [{ path: 'type', value: ProductType.BESTA_BOTTLE_RACK }],
      cluster: ['design']
    }
  ]
};

export default interiorsProductListConfig;
